module.exports = __webpack_public_path__ + "static/media/Start Screeen-01.9d61a6fa.webp";